<template>
  <div class="faqs-page" style="padding-top: 80px;">
    <section class="main-banner"></section>
    <section class="we-speak-german">
      <div>
        <div class="container mx-auto p-12">
          <div class="mb-12 text-center">
            <h2>Wir sprechen Deutsch!</h2>
          </div>
          <div>
            <h4 class="mb-4">Der Immobilienmarkt auf Malta</h4>
            <p class="mb-3 text-justify">
              Auf Malta geht nichts ohne Real Estate Agenten so gut wie nichts.
              Leider sind die meisten im Internet vorgestellten Häuser und
              Wohnungen aktuell gar nicht zur vermieten. Grundsätzlich kann man
              den Wohnungsmarkt nicht mit dem in Deutschland vergleichen.
            </p>
            <p class="mb-3 text-justify">
              Der wohl gravierendste Unterschied besteht darin eine unmöblierte
              Wohnung zu finden. Wohnungen mietet man auf Malta von einem Tag
              auf den anderen. Es ist so gut wie unmöglich eine Wohnung schon
              Monate im Voraus zu mieten.
            </p>
            <p class="mb-3 text-justify">
              <b>LOOP Homes</b> als Familienunternehmen hat sich auf die
              Vermietung, die Verwaltung von Immobilien und den Aufbau starker
              Bindungen zwischen Eigentümern und Mietern spezialisiert. LOOP
              Home bleibt auch nach dem Einzug als Gesprächspartner present.
            </p>
            <p class="mb-3 text-justify">
              <b>NextLevelMalta</b> ist spezialisiert auf innovative
              Lösungsansätze auf dem Gebiet Steigerung von Wirtschaftskraft- und
              Lebenspotentialen. Im Jahr 1989 gründeten wir die erste Limited
              auf Malta. Mit mehr als 30 Jahren Erfahrung, die wir auf Malta
              ansässig sind, wissen wir wie wichtig ein optimaler Support vor
              Ort ist.
            </p>
            <br />
            <h4 class="my-4">LOOP Homes und NextLevelMalta Kooperation</h4>
            <p class="mb-3 text-justify">
              Wir kennen Darren Abela, den Inhaber von LOOP Homes seit rund 20
              Jahren persönlich und haben zusammen viele Wünsche von Deutschen
              Wohnungssuchenden realisieren können. Wir kennen die Fallen, in
              die viele aus Unkenntnis tappen. Nutzen auch Sie die Vorteile der
              Kooperation und unseren breit aufgestellten Leistungen.
            </p>
            <p class="mb-3 text-justify">
              Gemeinsam sorgen LOOP Homes und NextLevelMalta dafür das
              deutschsprachige Wohnungssuchende rundum betreut werden. So halten
              wir eine Auswahl von ausgesuchten Häuser und exklusiven Wohnungen
              zur Miete für Sie bereit. Wir zeigen Ihnen nur Objekte die von
              NextLevelMalta abgenommen wurden.
            </p>
            <br />
            <h4 class="my-4">Service für Auswanderer</h4>
            <p class="mb-3 text-justify">
              Wenn wir die geeignete Immobilie für Sie gefunden haben, helfen
              wir auch bei der professionelle Erstellung von Anträgen zur ID-
              Card, Steuer- Nr., Social Insurance und JobPlus. Wir klären nicht
              nur die steuerlichen Möglichkeiten, sondern helfen auch beim Kauf
              von Auto und Boot. Wer sonst gibt Ihnen Starthilfe in der
              Eingewöhnungsphase wie Einkaufen, Kindergarten, Schulen und
              Behörden.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main-banner {
  @apply bg-cover bg-center text-white;
  background-image: url("~@/assets/wespeakgerman.jpeg");
  height: 60vh;
}

/deep/ a {
  @apply underline text-primary-color cursor-pointer;
}
</style>
